import { AUDIT } from "./check.js";

// The Audit as an itinerary. Each entry is a promise: change one only when the
// way we run an Audit changes. `minutes` is the client's own time for that step.
export const AUDIT_STEPS = [
  {
    when: "Today",
    what: "You book, or you talk to us first.",
    text: "Booking opens your own private page at once, with the agreement already on it. The call is twenty minutes and optional. Either way, a person answers within 24 hours.",
    minutes: 5,
  },
  {
    when: "Before day 1",
    what: "You sign, pay, and pick the day we start.",
    text: `You sign the agreement on your page and pay ${AUDIT.price} by card. Then you pick a time for the walkthrough, from the next working day on. That day is day 1: the two weeks run from it, not from the payment.`,
    minutes: 10,
  },
  {
    when: "Day 1",
    what: "You show us the job.",
    text: "The walkthrough. Someone who does the job shows it to us once, on a real case, on a call. From now on, everything we learn is written on your page as we learn it: the map as it grows, the open questions, the next step and its date.",
    minutes: 60,
  },
  {
    when: "Days 2–5",
    what: "We read.",
    text: "The systems the job touches, through read-only access or exports. We never ask anyone to share a password. The proof on day 14 needs this access by day 5. If it comes later, the document still arrives on day 14 and the proof follows within a week of the access.",
    minutes: 30,
  },
  {
    when: "Day 7",
    what: "The map, halfway.",
    text: "Every step of the job, written down, on your page. You tell us what we got wrong.",
    minutes: 30,
  },
  {
    when: "Days 8–12",
    what: "We size it, define the tool, and build the proof.",
    text: "The leaks in hours a month. What your software already allows. What the tool reads, what it prepares, and what waits for a person's approval. Then we build a first version that does one real case of yours.",
    minutes: 0,
  },
  {
    when: "Day 14",
    what: "The readout, and the proof.",
    text: "Forty-five minutes on a call. You watch the first version do one real case of yours: it reads your systems and prepares the work, and it sends and changes nothing. Then the document is yours: the map, the ledger of hours, a fixed price for the full tool, and a list of what you can fix without us.",
    minutes: 45,
  },
  {
    when: "After",
    what: "You decide, in your own time.",
    text: "The price holds for 30 days. If the Audit says do not build, there is no proof to run, and the document says why. Either way you keep everything.",
    minutes: 0,
  },
];
export const AUDIT_MINUTES = AUDIT_STEPS.reduce((sum, s) => sum + s.minutes, 0);
